// Configure dayjs for Ant Design 5
import dayjs from 'dayjs';
import 'dayjs/locale/vi'; // Vietnamese locale if needed
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Extend dayjs with plugins
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(timezone);
dayjs.extend(utc);

// Set default locale (optional)
// dayjs.locale('vi');

// Set default timezone to America/Los_Angeles (server timezone)
// This ensures dates are calculated based on server time, not user's local time
dayjs.tz.setDefault('America/Los_Angeles');

// Helper function to get current date in server timezone
export const getServerDate = () => dayjs().tz('America/Los_Angeles');

export default dayjs;
